/** Общий interact-range для Defuse raycast и Check aim-reveal. */
export const INTERACT_RANGE = 4
